import { render, staticRenderFns } from "./sum-display.vue?vue&type=template&id=5efcff79&scoped=true&"
import script from "./sum-display.vue?vue&type=script&lang=ts&"
export * from "./sum-display.vue?vue&type=script&lang=ts&"
import style0 from "./sum-display.vue?vue&type=style&index=0&id=5efcff79&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efcff79",
  null
  
)

export default component.exports